/**
 * "2 ชม.ที่แล้ว" จาก timestamp — ย้ายออกมาจาก PlatformConnectionCard ตอนที่ card ถูกแทน
 * ด้วย section + row พฤติกรรมเหมือนเดิมทุกประการ
 *
 * `t` เป็นพารามิเตอร์เพราะไฟล์นี้อยู่นอก React — เรียก hook ไม่ได้ และถ้าเขียนคำไว้
 * ตรง ๆ ผู้อ่านภาษาไทยจะเห็น "4d ago" ค้างอยู่ไม่ว่าจะสลับภาษากี่ครั้ง
 *
 * @module components/settings/formatLastSync
 */

import type { TFn } from "@/utils/channelCorrelation";

export const formatLastSync = (date: string | undefined, t: TFn): string => {
  if (!date) return t("settings.agoNever");
  const syncDate = new Date(date);
  const now = new Date();
  const diffMs = now.getTime() - syncDate.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMins < 1) return t("settings.agoJustNow");
  if (diffMins < 60) return t("settings.agoMinutes", { n: diffMins });
  if (diffHours < 24) return t("settings.agoHours", { n: diffHours });
  return t("settings.agoDays", { n: diffDays });
};

export default formatLastSync;
